// extracted by mini-css-extract-plugin
export default {"thank-you-manage-view":"styles__thank-you-manage-view___aMUk2","table":"styles__table___mV6SY"};